module.exports = __webpack_public_path__ + "static/media/avery.355a01cb.jpg";